import { render } from "./PolicyInsured.vue?vue&type=template&id=0654c48e"
import script from "./PolicyInsured.vue?vue&type=script&lang=js"
export * from "./PolicyInsured.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__